import {
  ROUTING_PROJECT_DATASET_FRAGMENT,
  ROUTING_PROJECT_DATASET_FRAGMENT_NAME
} from 'features/RoutingProjects/queries'
import { client } from 'gql/client'

interface IAddDatasetToRoutingProjectOptions {
  routingProjectId: string
  datasetId: string
  datasetName: string
}

export const addDatasetToRoutingProject = ({
  routingProjectId,
  datasetId,
  datasetName
}: IAddDatasetToRoutingProjectOptions): void => {
  client.cache.modify({
    id: client.cache.identify({
      __typename: 'RoutingProject',
      id: routingProjectId
    }),
    fields: {
      datasets(existingDatasets = []) {
        const newRoutingProjectDatasetRef = client.cache.writeFragment({
          data: {
            __typename: 'RoutingProjectDataset',
            id: datasetId,
            name: datasetName,
            locations: [],
            emptyDow: false
          },
          fragment: ROUTING_PROJECT_DATASET_FRAGMENT,
          fragmentName: ROUTING_PROJECT_DATASET_FRAGMENT_NAME
        })
        return [newRoutingProjectDatasetRef, ...existingDatasets]
      }
    }
  })
}
